









import Vue from 'vue'
import Person from './Person.vue'

export default Vue.extend({
  components: {
    Person
  }
})
